import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface StateDto {
  stateCode: number;
  stateName: string;
}

export interface ZipFullDescDto {
  stateCode: number;
  countyCode: number;
  cityCode: number;
  zipCode: number;
  zipName: string;
}

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private httpClient = inject(HttpClient);

  getStates(): Observable<StateDto[]> {
    return this.httpClient.get<StateDto[]>('locations/states');
  }

  getZipLocationsByState(stateCode: number): Observable<ZipFullDescDto[]> {
    return this.httpClient.get<ZipFullDescDto[]>(
      `locations/states/${stateCode}/ziplocations`
    );
  }
}
